import { ReactNode } from 'react';

interface Props {
  children: ReactNode;
  caption: string;
  'data-cy'?: string;
}

export function PolicyTableWrapper({
  children,
  caption,
  'data-cy': dataCy,
}: Props) {
  return (
    <div className="rounded-lg border border-gray-5 th-dark:border-gray-7 overflow-hidden">
      <table className="w-full" data-cy={dataCy}>
        <caption className="sr-only">{caption}</caption>
        {children}
      </table>
    </div>
  );
}
